import gql from 'graphql-tag';

export const allPhotosAccessInvitation = gql`
  mutation allPhotosAccessInvitation($input: AllPhotosAccessInvitationInput!) {
    allPhotosAccessInvitation(input: $input) {
      success
    }
  }
`;
